





















import {
  EstatisticaLeadService,
  ResultadoPorEtapa,
} from "@/services/estatistica-lead.service";
import ChartBar from "@/shared/components/chart-bar.vue";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import ComboCanalLead from "../../components/ComboCanalLead.vue";
import ComboTipoLead from "../../components/ComboTipoLead.vue";

import { etapaLead, statusLead } from "../../filters/filters";

const colors: { [key: number]: string } = {
  0: "#3fa9f5",
  1: "#ab248b",
  2: "#00c486",
  3: "#ff0000",
  4: "#38499c",
  5: "#83cf00",
};

const status: number[] = [1, 2, 3, 4, 9, 8];

@Component({
  components: {
    ChartBar,
    ComboTipoLead,
    ComboCanalLead,
  },
})
export default class GraficoResultadoPorEtapa extends Vue {
  loading = false;
  dados: ResultadoPorEtapa[] | null = null;
  idTipoLead: number | null = null;
  idCanalLead: number | null = null;
  @Prop({ required: true }) readonly data!: string;
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
    },
    scales: {
      yAxes: [
        {
          ticks: {
            precision: 0,
            beginAtZero: true,
          },
        },
      ],
    },
  };

  get labels() {
    return this.dados?.map((x) => etapaLead(x.idEtapaLead) || "Sem etapa");
  }
  get dataSets(): Chart.ChartDataSets[] {
    return status.map((status, i) => ({
      label: statusLead(status),
      backgroundColor: colors[i % 6],
      data: this.dados
        ?.map((etapa) => etapa.status.filter((x) => x.idStatusLead == status))
        .reduce((a, b) => a.concat(b), [])
        .map((status) => status.quantidade),
    }));
  }

  mounted() {
    this.fetchData();
  }

  timeout: number | null = null;
  @Watch("idTipoLead")
  @Watch("idCanalLead")
  onFormChange() {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.fetchData(), 300);
  }

  @Watch("data")
  async fetchData() {
    this.loading = true;
    try {
      this.dados = await EstatisticaLeadService.resultadoPorEtapa(
        moment(`${this.data}-01`).toDate(),
        this.idTipoLead || undefined,
        this.idCanalLead || undefined
      );
    } finally {
      this.loading = false;
    }
  }
}
